import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Calendar = forwardRef<SVGSVGElement, IconProps>(({ color = 'currentColor', size = 24 }, forwardedRef) => {
  return (
    <svg
      width={size}
      height={size}
      style={{ width: size, height: size }}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={forwardedRef}
    >
      <path
        d="M20.875 8.12122H4.03125V19.375C4.03125 19.9273 4.47897 20.375 5.03125 20.375L19.875 20.375C20.4273 20.375 20.875 19.9273 20.875 19.375V8.12122Z"
        fill="#2D425B"
        fillOpacity="0.05"
      />
      <path
        d="M4.03125 8.46875L20.875 8.46875L20.875 5.46875C20.875 4.91647 20.4273 4.46875 19.875 4.46875L5.03125 4.46875C4.47896 4.46875 4.03125 4.91647 4.03125 5.46875L4.03125 8.46875Z"
        fill="#2D425B"
        fillOpacity="0.1"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.21875 3.10657C8.49489 3.10657 8.71875 3.33042 8.71875 3.60657V4.01089H16.2812V3.60657C16.2812 3.33042 16.5051 3.10657 16.7812 3.10657C17.0574 3.10657 17.2812 3.33042 17.2812 3.60657V4.01089H19.5C20.6046 4.01089 21.5 4.90633 21.5 6.01089V19.1359C21.5 20.2405 20.6046 21.1359 19.5 21.1359H5.5C4.39543 21.1359 3.5 20.2405 3.5 19.1359V6.01089C3.5 4.90633 4.39543 4.01089 5.5 4.01089H7.71875V3.60657C7.71875 3.33042 7.94261 3.10657 8.21875 3.10657ZM16.2812 5.01089V6.25001C16.2812 6.52615 16.5051 6.75001 16.7812 6.75001C17.0574 6.75001 17.2812 6.52615 17.2812 6.25001V5.01089H19.5C20.0523 5.01089 20.5 5.45861 20.5 6.01089V8.01432C20.4838 8.01274 20.4675 8.01193 20.4509 8.01193L4.54909 8.01193C4.53253 8.01193 4.51615 8.01274 4.5 8.01431V6.01089C4.5 5.45861 4.94772 5.01089 5.5 5.01089H7.71875V6.25001C7.71875 6.52615 7.94261 6.75001 8.21875 6.75001C8.49489 6.75001 8.71875 6.52615 8.71875 6.25001V5.01089H16.2812ZM4.5 9.00955V19.1359C4.5 19.6882 4.94772 20.1359 5.5 20.1359H19.5C20.0523 20.1359 20.5 19.6882 20.5 19.1359V9.00955C20.4838 9.01113 20.4675 9.01193 20.4509 9.01193L4.54909 9.01193C4.53253 9.01193 4.51615 9.01113 4.5 9.00955ZM7.01343 14.0287H8.01343V15.0287H7.01343V14.0287ZM8.01343 10.9662H7.01343V11.9662H8.01343V10.9662ZM13.6384 14.0287H14.6384V15.0287H13.6384V14.0287ZM17.9509 14.0287H16.9509V15.0287H17.9509V14.0287ZM13.6384 10.9662H14.6384V11.9662H13.6384V10.9662ZM17.9509 10.9662H16.9509V11.9662H17.9509V10.9662ZM10.3259 14.0287H11.3259V15.0287H10.3259V14.0287ZM11.3259 10.9662H10.3259V11.9662H11.3259V10.9662ZM7.01343 17.0912H8.01343V18.0912H7.01343V17.0912ZM14.6384 17.0912H13.6384V18.0912H14.6384V17.0912ZM16.9509 17.0912H17.9509V18.0912H16.9509V17.0912ZM11.3259 17.0912H10.3259V18.0912H11.3259V17.0912Z"
        fill={color}
      />
    </svg>
  )
})

export default Calendar
